/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PricingPolicyEnhancedApplyFilterType {
    JOB_FAMILY = 'JOB_FAMILY',
    JOB_SUB_FAMILY = 'JOB_SUB_FAMILY',
    JOB_LEVEL = 'JOB_LEVEL',
    GRADE = 'GRADE',
    TAG = 'TAG',
}
